import { useEffect, useState } from "react";
import { responseMsg } from "../../common/ResponseMsg";
import { useForm } from "react-hook-form";
import SmsModal from './SmsModal';
import ScrollModal from '../../common/ScrollModal';
import Flex from '../../../shared/components/Flex';
import ModalButton from '../../../shared/components/ModalButton';
import Spacer from '../../../shared/components/Spacer';
import GridChild from '../../../shared/components/GridChild';
import Grid from '../../../shared/components/Grid';
import LabelInput from '../../../shared/components/LabelInput';
import ToggleSelect from '../../../shared/components/ToggleSelect';
import CommonSelect from '../../../shared/components/CommonSelect';
import useDevice from '../../../shared/hooks/useDevice';
import { useAlert } from '../../../shared/components/AlertProvider';

function UserEditModal({ user,rendering }) {
    const [roles, setRoles] = useState([]);
    const [alliance, setAlliance] = useState([]);
    const [selectedAlliance, setSelectedAlliance] = useState();
    const [selectedRole, setSelectedRole] = useState();
    const [smsModal, setSmsModal] = useState({});
    const { register, handleSubmit, formState: { isSubmitting, isDirty, errors } } = useForm({
        defaultValues: user
    });
    const [useYn, setUseYn] = useState(user?.useYn || "Y");
    const device = useDevice();
    const isMobile = device !== 'desktop';
    const showAlert = useAlert();

    const useYnOption = [
        {text: "사용", value: "Y"},
        {text: "미사용", value: "N"}
    ]

    // 모달 (SMS)
    const openSmsModal = (cell) => {

        setSmsModal({
            ...smsModal,
            open: true,
            close: closeSmsModal,
            main: <SmsModal 
                userId={user.userId}
                closeSmsModal={closeSmsModal}
            />
        });
    };

    const closeSmsModal = () => {

        setSmsModal({
            ...smsModal,
            open : false,
        });
    };

    const onUpdateHandler = (formData) => {
        if (formData.userNm.trim() === '') {
            showAlert({title: "주의", text: "사용자명을 입력해주세요.", type: "warning" });
            return;
        } else if (formData.cellNo.trim() === '') {
            showAlert({title: "주의", text: "전화번호를 입력해주세요.", type: "warning" });
            return;
        } else if (formData.email.trim() === '') {
            showAlert({title: "주의", text: "이메일을 입력해주세요.", type: "warning" });
            return;
        }
        fetch("/api/system/users", {
            method: "PATCH",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ ...formData, allianceId: selectedAlliance, roleId: selectedRole, useYn: useYn }),
        })
            .then((res) => res.json())
            .then((json) => {
                if (json.code === responseMsg.SUCCESS.code) {
                    showAlert({title: "알림", text: "수정완료"});
                    rendering();

                } else if (json.code === responseMsg.USER_DUPL_EMAIL.code) {
                    showAlert({title: "경고", text: responseMsg.USER_DUPL_EMAIL.message, type: "warning"});

                } else if (json.code === responseMsg.USER_DUPL_CELL_NO.code) {
                    showAlert({title: "경고", text: responseMsg.USER_DUPL_CELL_NO.message, type: "warning"});

                } else if (json.code === responseMsg.FAIL.code) {
                    showAlert({title: "경고", text: "통신이 지연되고 있습니다.", type: "warning"});
                }
            })
            .catch((error) => {
            });
    }

    const onDeleteHandler = () => {
        fetch(`/api/system/users/${user.userId}`, {
            method: "DELETE",
        })
            .then((res) => res.json())
            .then((json) => {
                if (json.code === responseMsg.SUCCESS.code) {
                    showAlert({title: "알림", text: "삭제완료"});
                    rendering();

                } else if (json.code === responseMsg.FAIL.code) {
                    showAlert({title: "경고", text: "통신이 지연되고 있습니다.", type: "warning"});
                }
            })
            .catch((error) => {
            });
    }

    const autoHyphen = (target) => {
        target.value = target.value
            .replace(/[^0-9]/g, '')
            .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3").replace(/(\-{1,2})$/g, "");
    }
    
    useEffect(() => {

        fetch("/api/system/roles", {
            method: "GET"
        })
            .then((res) => res.json())
            .then((json) => {
                if (json.code === responseMsg.SUCCESS.code) {
                    setSelectedRole(user.roleId)
                    const newRolesList = json.data.map((item) => ({
                        ...item,
                        text: item.encodedNm,
                        value: item.id
                    }));
                    setRoles(newRolesList)
                } else if (json.code === responseMsg.FAIL.code) {
                    showAlert({title: "경고", text: "통신이 지연되고 있습니다.", type: "warning"});
                }
            })
            .catch((error) => {
            });

        fetch("/api/system/alliances", {
            method: "GET"
        })
            .then((res) => res.json())
            .then((json) => {
                if (json.code === responseMsg.SUCCESS.code) {
                    const newAlliance = json.data.map((item) => ({
                        ...item,
                        text: item.allianceName,
                        value: item.id
                    }));
                    setAlliance(newAlliance)
                    setSelectedAlliance(user.allianceId)

                } else if (json.code === responseMsg.FAIL.code) {
                    showAlert({title: "경고", text: "통신이 지연되고 있습니다.", type: "warning"});
                }
            })
            .catch((error) => {
            });
    }, [])

    return (
        <>
            <div>
                <Grid paddingX={0}>
                    <GridChild span={2}>
                        <LabelInput id="userId" label={'아이디'} defaultValue={user?.userId} style={{backgroundColor: "#F5F7F9"}} readOnly {...register("userId")} />
                    </GridChild>
                    <GridChild>
                        <LabelInput id="userName" label={'사용자명'} maxLength={200} placeholder="사용자명을 입력해 주세요" defaultValue={user?.userNm} required autoFocus {...register("userNm")}/>
                    </GridChild>
                    <GridChild>
                        <LabelInput id="userDept" label={'부서'} maxLength={50} placeholder="부서를 입력해 주세요" defaultValue={user?.department} {...register("department")} />
                    </GridChild>
                    <GridChild>
                        <LabelInput id="cellNo" label={'전화번호'} maxLength={13} placeholder="전화번호를 입력해 주세요" defaultValue={user?.cellNo} required {...register("cellNo",{
                                onChange: ({ target }) => autoHyphen(target),
                            })} />
                    </GridChild>
                    <GridChild>
                        <LabelInput id="userEmail" label={'이메일'} maxLength={50} placeholder="이메일을 입력해 주세요" defaultValue={user?.email} required {...register("email")} />
                    </GridChild>
                    <GridChild>
                        <CommonSelect label="권한" value={selectedRole} isModal data={roles} onChange={setSelectedRole} />
                    </GridChild>
                    <GridChild>
                        <CommonSelect label="소속" value={selectedAlliance} isModal data={alliance} onChange={setSelectedAlliance} />
                    </GridChild>
                    <GridChild span={2}>
                        <LabelInput id="userRemark" label={'비고'} maxLength={255} defaultValue={user?.comment} {...register("comment")} />
                    </GridChild>
                    <GridChild span={2}>
                        <ToggleSelect
                            label="사용여부"
                            name="usage_status"
                            options={useYnOption}
                            onChange={(value) => setUseYn(value)}
                            initialValue={useYn}
                        />
                    </GridChild>
                </Grid>
                
                <Spacer direction='vertical' size={30} />

                <Flex flexDirection={isMobile ? "column" : "row"} fullWidth justifyContent="space-between" gap={10}>
                    <ModalButton type='default' onClick={openSmsModal} text='SMS 연동 상세 조회' />
                    <Flex flexDirection={isMobile ? "column" : "row"} fullWidth justifyContent="end" gap={10}>
                        <ModalButton type='update' onClick={handleSubmit(onUpdateHandler)} />
                        <ModalButton type='delete' onClick={handleSubmit(onDeleteHandler)} /> 
                        <ModalButton type='cancel' onClick={rendering} />
                    </Flex> 
                </Flex>
            </div>

            <ScrollModal
                headerText="SMS 연동"
                size="402px"
                maxWidth="402px"
                modal={smsModal}
            >
            </ScrollModal>
        </>
    );
}

export default UserEditModal;